import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'


let loading
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中....',
    background: 'rgba(0, 0, 0, 0)'
  })
}
function endLoading() {
  loading.close()
}
// const baseURL = process.env.API;
  // const baseURL = "http://202.101.187.181:39999"; // 日常测试环境
  // const baseURL = "http://202.101.187.181:19999"; // 项目测试环境
  const baseURL = "https://mp.chicun.store"; // 线上环境

axios.defaults.headers.post["Content-Type"] = "text/plain;charset=UTF-8";

// create an axios instance
const service = axios.create({
  baseURL: baseURL, //   'https://mp.chicun.store',  // api的base_url
  timeout: 10000, // request timeout,
  headers: {
    // Authorization: 'Bearer 26c3d630-ad2a-49ce-a8af-3fbeb9401152',
    "Content-Type": "application/json;charset=UTF-8"
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // startLoading()
    // 携带
    // let coToken = getToken()
    // if (coToken) {
    //   config.headers['Authorization'] = getToken()
    // }
    // config.headers['Client-Type'] = "PC"
    // endLoading()
    return config
  },
  error => {
    // endLoading()
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {
    const res = response.data

    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
